import { CancelToken } from 'axios';
import { API_V2 } from '@front-app/services/api';
import {
	InvitationCampaignInvitee,
	FetchInviteesRequestParams,
	InviteeCountsResponse,
	UpdateInviteeStatusesRequest,
	InviteeStatus,
} from '@front-app/services/GroupInvitationCampaignApi/model';

export function fetchCampaignInvitees(
	groupId: string,
	campaignId: string,
	pageNum: number,
	params: FetchInviteesRequestParams,
	cancelToken?: CancelToken,
): Promise<InvitationCampaignInvitee[]> {
	return API_V2.get(`/groups/${groupId}/invitations/${campaignId}/users/page/${pageNum}`, { params, cancelToken })
		.then(({ data }) => data as InvitationCampaignInvitee[]);
}

export function fetchCampaignInviteeCounts(groupId: string, campaignId: string): Promise<InviteeCountsResponse> {
	return API_V2.get(`/groups/${groupId}/invitations/${campaignId}/users/counts`)
		.then(({ data }) => data as InviteeCountsResponse);
}

export function fetchInviteeInvites(groupId: string, campaignId: string, inviteeId: string): Promise<Date[]> {
	return API_V2.get(`/groups/${groupId}/invitations/${campaignId}/users/${inviteeId}/invites`)
		.then(({ data }) => data as Date[])
}

export function updateInviteeStatus(
	groupId: string,
	campaignId: string,
	invitees: UpdateInviteeStatusesRequest,
): Promise<InvitationCampaignInvitee[]> {
	return API_V2.put(`/groups/${groupId}/invitations/${campaignId}/users`, invitees)
		.then(({ data }) => data as InvitationCampaignInvitee[]);
}

export function pauseOrResumeStatuses(
	groupId: string,
	campaignId: string,
	status: InviteeStatus,
): Promise<void> {
	return API_V2.post(`/groups/${groupId}/invitations/${campaignId}/users?status=${status}`);
}
